export default __webpack_public_path__ + "static/media/controls_mouse_1.a3270c27.svg";